export interface Expiration {
    quantity: number;
    unit: ExpirationUnit;
    day: number;
    initial_month: number;
}

export type ExpirationUnit = 'MONTH' | 'YEAR';

export const EXPIRATION_UNITS: ExpirationUnit[] = ['MONTH', 'YEAR'];